<fuse-navigation layout="horizontal"></fuse-navigation>